import { render, staticRenderFns } from "./PreGamePlayerSlot.vue?vue&type=template&id=7e1a25fc&"
import script from "./PreGamePlayerSlot.vue?vue&type=script&lang=js&"
export * from "./PreGamePlayerSlot.vue?vue&type=script&lang=js&"
import style0 from "./PreGamePlayerSlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e1a25fc')) {
      api.createRecord('7e1a25fc', component.options)
    } else {
      api.reload('7e1a25fc', component.options)
    }
    module.hot.accept("./PreGamePlayerSlot.vue?vue&type=template&id=7e1a25fc&", function () {
      api.rerender('7e1a25fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Player/PreGamePlayerSlot.vue"
export default component.exports